import { useEffect, useRef } from 'react';

import { Location, useLocation } from 'react-router';

type ChangeFunction = (location?: Location, prevLocation?: Location) => void;

export const useLocationChange = (fn: ChangeFunction) => {
  const location = useLocation();
  const prevLocation = useRef<Location | undefined>(undefined);

  useEffect(() => {
    fn(location, prevLocation.current);
    prevLocation.current = location;
  }, [fn, location]);
};
